export default `blog-toc-title = En este artículo

`;